window["VueCustomBuildLightbox"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        thumbnail: String,
        images: Array,
        alternateText: String,
        // if is_enabled=false is passed then component will be hidden. Useful when dealing with multiple Lightboxes on one page
        is_enabled: {
            'type': Boolean,
            'default': true
        }
    },
    data: function data() {
        return {
            visible: false,
            index: 0,
            displayImage: true
        };
    },

    computed: {
        hasNext: function hasNext() {
            return this.index + 1 < this.images.length;
        },
        hasPrevious: function hasPrevious() {
            return this.index - 1 >= 0;
        }
    },
    methods: {
        show: function show() {
            this.visible = true;
            //this.index = 0
        },
        hide: function hide() {
            this.visible = false;
            //this.index = 0
        },
        previous: function previous() {
            if (this.hasPrevious) {
                this.index -= 1;
                this.tick();
            }
        },
        next: function next() {
            if (this.hasNext) {
                this.index += 1;
                this.tick();
            }
        },

        // Can be used to manually set which image should be shown
        setIndex: function setIndex(index) {
            this.index = index;
        },
        tick: function tick() {
            var _this = this;

            if (!this.$slots.loader) {
                return;
            }

            this.displayImage = false;

            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
                _this.displayImage = true;
            });
        },
        eventListener: function eventListener(e) {
            if (this.visible) {
                switch (e.key) {
                    case 'ArrowRight':
                        return this.next();
                    case 'ArrowLeft':
                        return this.previous();
                    case 'ArrowDown':
                    case 'ArrowUp':
                    case ' ':
                        return e.preventDefault();
                    case 'Escape':
                        return this.hide();
                }
            }
        }
    },
    mounted: function mounted() {
        window.addEventListener('keydown', this.eventListener);
    },
    destroyed: function destroyed() {
        window.removeEventListener('keydown', this.eventListener);
    }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    //
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lightbox", function() { return Lightbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_Lightbox_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_LightboxDefaultLoader_vue__ = __webpack_require__(8);



var Lightbox = {
    install: function install(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        Vue.mixin({
            components: {
                lightbox: __WEBPACK_IMPORTED_MODULE_0__Components_Lightbox_vue__["a" /* default */],
                LightboxDefaultLoader: __WEBPACK_IMPORTED_MODULE_1__Components_LightboxDefaultLoader_vue__["a" /* default */]
            }
        });
    }
};

if (typeof window !== 'undefined') {
    if (window.Vue) {
        window.Vue.use(Lightbox);
    }

    window.Lightbox = Lightbox;
}


/* harmony default export */ __webpack_exports__["default"] = (Lightbox);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_vagrant_node_modules_vue_loader_lib_selector_type_script_index_0_Lightbox_vue__ = __webpack_require__(1);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_vagrant_node_modules_vue_loader_lib_template_compiler_index_id_data_v_42aed322_hasScoped_false_buble_transforms_home_vagrant_node_modules_vue_loader_lib_selector_type_template_index_0_Lightbox_vue__ = __webpack_require__(7);
function injectStyle (ssrContext) {
  __webpack_require__(5)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_vagrant_node_modules_vue_loader_lib_selector_type_script_index_0_Lightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__home_vagrant_node_modules_vue_loader_lib_template_compiler_index_id_data_v_42aed322_hasScoped_false_buble_transforms_home_vagrant_node_modules_vue_loader_lib_selector_type_template_index_0_Lightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

(function() { module.exports = window["Vue"]; }());

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_enabled)?_c('div',[_c('a',{staticClass:"lightbox__thumbnail",attrs:{"href":_vm.images[0],"target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.show($event)}}},[_c('img',{attrs:{"src":_vm.thumbnail,"alt":_vm.alternateText}})]),_vm._v(" "),(_vm.visible)?_c('div',{staticClass:"lightbox",on:{"click":_vm.hide}},[_c('div',{staticClass:"lightbox__close",on:{"click":_vm.hide}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"lightbox__element",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"lightbox__arrow lightbox__arrow--left",class:{ 'lightbox__arrow--invisible': !_vm.hasPrevious },on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.previous($event)}}},[_c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0-.5h24v24H0z","fill":"none"}})])]),_vm._v(" "),_c('div',{staticClass:"lightbox__image",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.$slots.loader)?_vm._t("loader"):_vm._e(),_vm._v(" "),(_vm.displayImage)?_c('img',{attrs:{"src":_vm.images[_vm.index]}}):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"lightbox__arrow lightbox__arrow--right",class:{ 'lightbox__arrow--invisible': !_vm.hasNext },on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.next($event)}}},[_c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0-.25h24v24H0z","fill":"none"}})])])])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_vagrant_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxDefaultLoader_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_vagrant_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5941fc0c_hasScoped_false_buble_transforms_home_vagrant_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxDefaultLoader_vue__ = __webpack_require__(10);
function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_vagrant_node_modules_vue_loader_lib_selector_type_script_index_0_LightboxDefaultLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__home_vagrant_node_modules_vue_loader_lib_template_compiler_index_id_data_v_5941fc0c_hasScoped_false_buble_transforms_home_vagrant_node_modules_vue_loader_lib_selector_type_template_index_0_LightboxDefaultLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lightbox__default-loader"},[_c('div',{staticClass:"lightbox__default-loader__element"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// custom-build-lightbox.js